// import React, { useContext, useState } from 'react';
// import { Button, Form } from 'react-bootstrap';
// import axios from 'axios';
// import { toast } from 'react-toastify';

// import {
//   BronzeCreditTokenLimit,
//   BronzeTrialTokenLimit
// } from 'app/api/MemberService';
// import UserContext from 'app/context/UserContext';

// function BronzeLimit() {
//   const { user } = useContext(UserContext);

//   const [trialTokenLimit, setTrialTokenLimit] = useState('');
//   const [creditPurchaseToken, setCreditPurchaseToken] = useState('');

//   const handleTrialSave = async e => {
//     e.preventDefault();
//     try {
//       await axios.request(
//         BronzeTrialTokenLimit(user.token, {
//           trialTokenLimit
//         })
//       );

//       toast.success('Trial token limit saved successfully', {
//         theme: 'colored'
//       });
//     } catch (error) {
//       toast.error('Failed to save trial token limit', {
//         theme: 'colored'
//       });
//       console.error(error);
//     }
//   };

//   const handleCreditSave = async e => {
//     e.preventDefault();
//     try {
//       await axios.request(
//         BronzeCreditTokenLimit(user.token, {
//           creditPurchaseToken
//         })
//       );

//       toast.success('Credit purchase token saved successfully', {
//         theme: 'colored'
//       });
//     } catch (error) {
//       toast.error('Failed to save credit purchase token', {
//         theme: 'colored'
//       });
//       console.error(error);
//     }
//   };

//   return (
//     <Form>
//       {/* Trial Token Limit */}
//       <Form.Group className="mb-4">
//         <Form.Label>Trial Token Limit</Form.Label>
//         <Form.Control
//           type="number"
//           placeholder="Enter trial token limit"
//           value={trialTokenLimit}
//           onChange={e => setTrialTokenLimit(e.target.value)}
//         />
//         <Button
//           className="mt-2"
//           variant="primary"
//           onClick={handleTrialSave}
//         >
//           Save
//         </Button>
//       </Form.Group>

//       {/* Credit Purchase Token */}
//       <Form.Group className="mb-4">
//         <Form.Label>Credit Purchase Token</Form.Label>
//         <Form.Control
//           type="number"
//           placeholder="Enter credit purchase token"
//           value={creditPurchaseToken}
//           onChange={e => setCreditPurchaseToken(e.target.value)}
//         />
//         <Button
//           className="mt-2"
//           variant="primary"
//           onClick={handleCreditSave}
//         >
//           Save
//         </Button>
//       </Form.Group>
//     </Form>
//   );
// }

// export default BronzeLimit;

import React, { useContext, useState, useEffect } from 'react';
import UserContext from 'app/context/UserContext';
import {
  Modal,
  Button,
  CloseButton,
  Spinner,
  Row,
  Col,
  Form
} from 'react-bootstrap';
import { toast } from 'react-toastify';
import axios from 'axios';
import PropTypes from 'prop-types';
import { create, update } from 'app/api/TaskPriceService';

const ModalUpload = ({
  showModal,
  handlerShowModal,
  updateTable,
  taskToEdit
}) => {
  const { user } = useContext(UserContext);

  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState('');
  const [noOfCost, setNoOfCost] = useState('');
  const [noOfRewards, setNoOfRewards] = useState('');
  const [fileType, setFileType] = useState('file');
  const [taskType, setTaskType] = useState(true);
  const [impressionId, setImpressionId] = useState('');

  useEffect(() => {
    if (taskToEdit) {
      setTitle(taskToEdit.title || '');
      setNoOfCost(taskToEdit.noOfCost || '');
      setNoOfRewards(taskToEdit.noOfRewards || '');
      setFileType(taskToEdit.type || 'file');
      setTaskType(taskToEdit.isTaskType);
    }
  }, [taskToEdit]);

  const handlerShowingModal = () => {
    setTitle('');
    setNoOfCost('');
    setNoOfRewards('');
    setFileType('file');
    setTaskType(true);
    setImpressionId('');
    handlerShowModal();
  };

  const handlerSave = async () => {
    setLoading(true);
    try {
      const formData = taskType
        ? {
            title,
            type: fileType,
            noOfRewards: Number(noOfRewards),
            noOfCost: Number(noOfCost),
            isTaskType: taskType
          }
        : {
            title,
            type: fileType,
            isTaskType: taskType,
            impressionId
          };

      const response = taskToEdit
        ? await axios.request(update(user.token, taskToEdit.id, formData))
        : await axios.request(create(user.token, formData));

      if (response.data.success) {
        updateTable();
        toast.success(response.data.message || 'Success', { theme: 'colored' });
        handlerShowingModal();
      } else {
        toast.error(response.data.message || 'Operation failed.');
      }
    } catch (error) {
      toast.error('An error occurred.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      show={showModal}
      onHide={handlerShowingModal}
      size="lg"
      centered
    >
      <Modal.Header>
        <Modal.Title>
          {taskToEdit ? 'Edit Task Pricing' : 'Add Task Pricing'}
        </Modal.Title>
        <CloseButton onClick={handlerShowingModal} />
      </Modal.Header>

      <Modal.Body>
        <Form.Group className="mb-3">
          <Form.Label>Title</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter task title"
            value={title}
            onChange={e => setTitle(e.target.value)}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Task Type</Form.Label>
          <Form.Select
            disabled={!!taskToEdit}
            value={String(taskType)}
            onChange={e => setTaskType(e.target.value === 'true')}
          >
            <option value="true">Task</option>
            <option value="false">Impression</option>
          </Form.Select>
        </Form.Group>

        {taskType && (
          <>
            <Form.Group className="mb-3">
              <Form.Label>Cost</Form.Label>
              <Form.Control
                type="number"
                value={noOfCost}
                onChange={e => setNoOfCost(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Rewards</Form.Label>
              <Form.Control
                type="number"
                value={noOfRewards}
                onChange={e => setNoOfRewards(e.target.value)}
              />
            </Form.Group>
          </>
        )}

        <Form.Group className="mb-3">
          <Form.Label>File Type</Form.Label>
          <Form.Select
            value={fileType}
            onChange={e => setFileType(e.target.value)}
          >
            <option value="file">File</option>
            <option value="url">URL</option>
          </Form.Select>
        </Form.Group>

        {!loading ? (
          <Row>
            <Col>
              <Button variant="success" onClick={handlerSave}>
                {taskToEdit ? 'Update' : 'Save'}
              </Button>
            </Col>
            <Col className="d-flex justify-content-end">
              <Button variant="outline-primary" onClick={handlerShowingModal}>
                Close
              </Button>
            </Col>
          </Row>
        ) : (
          <Button variant="primary" disabled>
            <Spinner size="sm" animation="border" />
            <span className="ms-2">Loading...</span>
          </Button>
        )}
      </Modal.Body>
    </Modal>
  );
};

ModalUpload.propTypes = {
  showModal: PropTypes.bool,
  handlerShowModal: PropTypes.func,
  updateTable: PropTypes.func,
  taskToEdit: PropTypes.object
};

export default ModalUpload;
